import {
  SET_CURRENT_ONBOARDING_STEP,
  RESET_ONBOARDING,
  SET_SIGNUP_PAYLOAD,
  SET_SELECTED_THEMES_IDS,
} from './onboardingTypes'

import { getItemStorage } from '@/utils/storage'
import Constants from '@/utils/constants'

const initialState = {
  currentOnboardingStep: getItemStorage(Constants.CURRENT_ONBOARDING_STEP, 0),
  signupPayload: {},
  selectedThemesIds: [],
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CURRENT_ONBOARDING_STEP:
      return {
        ...state,
        currentOnboardingStep: payload,
      }
    case RESET_ONBOARDING: {
      return {
        ...state,
        currentOnboardingStep: 0,
      }
    }
    case SET_SIGNUP_PAYLOAD: {
      return {
        ...state,
        signupPayload: payload,
      }
    }
    case SET_SELECTED_THEMES_IDS: {
      return {
        ...state,
        selectedThemesIds: payload,
      }
    }
    default:
      return state
  }
}
